module.exports = __webpack_public_path__ + "img/instagram-icon.448150b5.svg";